import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getPDFProformaPresupuesto (payload, params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getUploadFacturae.data)
    })
  } else {
    const req = {
      url: '/api/emisionfacturas/getpdfproformapresupuesto',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      responseType: 'blob',
      data: payload,
      params
    }
    const res = await axiosInstance(req)
    return { data: res.data, headers: res.headers }
  }
}

export { getPDFProformaPresupuesto }
